import React from "react";
import Checkbox from "../Checkbox";
import { formatServiceLabel, isOn, serviceEntries } from "../../carrierHelpers";

const ServiceChecklist = ({ row, onChange, disabled, inline = false }) => {
  const services = serviceEntries(row);
  // "All services" is disabled until the bulk services API exists: one request per service was too slow.
  // const onCount = services.filter(([, value]) => isOn(value)).length;
  // const allState =
  //   onCount === services.length ? true : onCount === 0 ? false : "mixed";
  //
  // const setAll = () => {
  //   const next = allState !== true;
  //   onChange(
  //     Object.fromEntries(
  //       services.filter(([, value]) => isOn(value) !== next).map(([key]) => [key, next]),
  //     ),
  //   );
  // };

  return (
    <div
      className={
        inline
          ? "flex flex-wrap items-center gap-x-[22px] gap-y-2.5 rounded-lg border border-ui-border bg-ui-surface px-3 py-2.5"
          : "flex flex-col gap-2"
      }
    >
      {/* Disabled until the bulk services API exists.
      <div
        className={`flex items-center gap-2 font-semibold text-ui-text-muted ${
          inline ? "border-r border-ui-border pr-4 text-xs" : "text-[11px]"
        }`}
      >
        <Checkbox checked={allState} onChange={setAll} label="All services" disabled={disabled} />
        <span>All services</span>
      </div> */}
      <div className={inline ? "contents" : "grid grid-cols-2 gap-x-3 gap-y-2"}>
        {services.map(([key, value]) => (
          <div key={key} className="flex min-w-0 items-center gap-2 text-xs text-ui-text">
            <Checkbox
              checked={isOn(value)}
              onChange={() => onChange({ [key]: !isOn(value) })}
              label={formatServiceLabel(key)}
              disabled={disabled}
            />
            <span>{formatServiceLabel(key)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceChecklist;
